import { Avatar, Box, Collapse, Divider, List, ListItem, ListItemButton } from '@mui/material'
import React from 'react'
import { useContext } from 'react'
import { ToolContext } from '../../../../../core/context/ToolContext'
import { ExpandLess, ExpandMore, HeadsetMic, HelpOutline, Logout } from '@mui/icons-material'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import { UsageAverage } from './UsageAverage'

const More = () => {
    const { tool_state, install_state, personalization_state, navigation_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const  {prompt, ip } = install_state
    const { walkthrough } = personalization_state
    const { help } = navigation_state

    const pinfo = __SESSION.data.pinfo[0]
    const ainfo = __SESSION.data.ainfo
    
    const history = useHistory()
    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8)
    const tool_id = process.env.REACT_APP_TID_PSL;
    
    const [userSetting, setUserSetting] = useState([
        {label: 'Help', ref: 'help', icon: <HelpOutline sx={{color: '#292C2F', fontSize: '22px'}}/>, toggled: false, type: 'dropdown', 
            children: []
        },
        {label: 'Support', ref: 'support', icon: <HeadsetMic sx={{color: '#292C2F', fontSize: '22px'}}/>, toggled: false, type: 'link', children: []},
        {label: 'Logout', ref: 'logout', icon: <Logout sx={{color: '#292C2F', fontSize: '22px'}}/>, toggled: false, type: 'link', children: []},
    ])


    useEffect(() => {
        const __checkOnboarding = async () => {
            let data = await rqx.get(`<<global>>/${env()}/personalization/read`,{ tool_id: tool_id, user_id: user_id, ref: 'onboarding' });
            if (data.length > 0) {
                const p = JSON.parse(data[0].personalization);
                const onboarding = p.find(x => x.sf_name === "onboading");
                const general = p.find(x => x.sf_name === "general");

                if (onboarding?.status === 0) {
                    history.push("/psl/onboarding")
                } else if(general?.status === 0) {
                    walkthrough.set(prev => ({ ...prev, general: true }));
                }
            } else {
                history.push("/psl/onboarding")
            }
        };
        __checkOnboarding()

        // eslint-disable-next-line
    }, [])

    const clickListHandler = (ref, id) => {
        if (ref === 'help') {
            setUserSetting(prev =>
                prev.map((v, i) =>
                    i === id ? { ...v, toggled: !v.toggled } : v
                )
            );
        } else if (ref === 'tour-me') {
            if (ref === 'tour-me') {
                help.set(prev => ({...prev, feature_list: prev.feature_list.map((v, i) => i === id ? {...v, toggled : !v.toggled} : v)}))
            }
        } else if(ref === 'support') {
            window.chaport.open()
        } else if (ref === 'logout') {
            if (prompt.data !== null && !('serviceWorker' in navigator && window.matchMedia('(display-mode: standalone)').matches)) {
                ip.set({stat: true, prompt_type: 'logout'})
            } else {
                localStorage.removeItem('ptx_psl_session')
                window.location.href = '/psl'
            }
        } else if (ref === 'faq') {
            const newWindow = window.open(process.env.REACT_APP_WS_URL, '_blank', 'noopener,noreferrer');
            if (newWindow) {
                newWindow.opener = null;
            }
        } else {
            walkthrough.set(prev => ({...prev, [ref]: true})) 
            if (ref === 'save') {
                history.push('/psl/save')
            } else if (ref === 'publication' || ref === 'general') {
                history.push('/psl/publication?tab=article')
            }
        }
    }

    return (
        <Box height="100dvh" display="flex" flexDirection="column" gap="28px" py="24px">
            <List disablePadding>
                <ListItemButton sx={{display:'flex', alignItems: 'center', gap: '16px'}}>
                    <Avatar src={pinfo !== undefined ? (pinfo.profile !== null ? JSON.parse(pinfo.profile).profile : null) : null} sx={{width: '80px', height: '80px', border: '2px solid #D6D9DB'}}/>
                    <Box display="flex" flexDirection="column">
                        {
                            pinfo === undefined ?
                                <Box fontSize="16px" fontWeight="600">{ainfo.email}</Box>
                            :
                                <>
                                    <Box fontSize="16px" fontWeight="600">{`${pinfo.first_name} ${pinfo.last_name}`}</Box>
                                    <Box fontSize="14px">{ainfo.email}</Box>
                                    <Box fontSize="14px" color="#0D62BE">Work Account</Box>
                                </>
                        }
                    </Box>
                </ListItemButton>
            </List>
            <Box px="16px" display="flex" flexDirection="column" gap="28px">
                <UsageAverage/>
            </Box>
            <Divider variant='middle'/>
            <List disablePadding>
                {
                    userSetting.map((v, i) => (
                        <React.Fragment key={i}>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => clickListHandler(v.ref, i)} sx={{display:'flex', alignItems: 'center', gap: '18px', p: '16px 20px'}}>
                                    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                                        <Box display="flex" alignItems="center" gap="8px">
                                                <Box display="flex" justifyContent="center" alignContent="center" sx={{height: '24px', width: '24px'}}>
                                                    {v.icon}
                                                </Box>
                                                <Box fontSize="14px">{v.label}</Box>
                                        </Box>
                                        {v.type === 'dropdown' && <Box>{ v.toggled ? <ExpandLess /> : <ExpandMore /> }</Box>}
                                    </Box>
                                </ListItemButton>
                            </ListItem>
                            <Collapse in={v.toggled}>
                                <List disablePadding>
                                    {help.data.feature_list.map((c, n) => (
                                        <React.Fragment key={n}>
                                            <ListItemButton key={n} onClick={() => clickListHandler(c.ref, n)} sx={{display:'flex', alignItems: 'center', gap: '18px', p: '16px 20px', ml: '32px'}}>
                                                <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                                                    <Box fontSize="14px">{c.name}</Box>
                                                    {c.type === 'dropdown' && 
                                                        <Box display="flex" alignItems="center" justifyItems="center">
                                                            {c.toggled ? <ExpandLess /> : <ExpandMore /> }
                                                        </Box>
                                                    }
                                                </Box>
                                            </ListItemButton>
                                            <Collapse in={c.toggled}>
                                                <List disablePadding>
                                                    {
                                                        c.sub_feature_list.map((sf, d) => (
                                                            <ListItemButton key={d} onClick={() => clickListHandler(sf.ref, d)} sx={{display:'flex', alignItems: 'center', gap: '18px', p: '16px 20px', ml: '64px'}}>
                                                                    <Box fontSize="14px">{sf.name}</Box>
                                                            </ListItemButton>
                                                        ))
                                                    }
                                                </List>
                                            </Collapse>
                                        </React.Fragment>

                                    ))}
                                </List>
                            </Collapse>
                        </React.Fragment>
                    ))
                }
            </List>
        </Box>
    )
}

export default More
